import React from 'react';
import { Input } from 'antd';
import { debounce } from "lodash";


import './index.css';

export const InputBox =  (props) => {
  const  { placeholder, pdfTextSearchCall}= props;
  const handleChange = debounce((e) =>pdfTextSearchCall(e), 1000) 
  return (
    <div>
      <Input onChange={e =>handleChange(e.target.value)} style={{width:'42%'}} placeholder={placeholder} />
    </div>
  );
};

